<template>
  <div>
    <h2 class="title">
      {{ title }}
    </h2>
    <el-row>
      <el-col :span="6">
        <div class="edit-table-list">
          <div class="table-vertical">
            <h2 class="totalQty">
              {{ shipCount }}
            </h2>
            <h3 class="subTitle">
              {{ subTitle[0] }}
              <div class="edit-button-wrap">
                <i
                    class="refresh-icon fas fa-sync-alt"
                    @click="getShipmentSummarys()" />
              </div>
            </h3>
            <BaseTableDetail
                :border="true"
                class="summary-table"
                :table-set-list="shipTableSetList"
                :display-item="shipmentSummarys" />
            <h3 class="noData">
              {{ shipNoData }}
            </h3>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="edit-table-list">
          <div class="table-vertical">
            <h2 class="totalQty">
              {{ exportCount }}
            </h2>
            <h3 class="subTitle">
              {{ subTitle[1] }}
              <div class="edit-button-wrap">
                <i
                    class="refresh-icon fas fa-sync-alt"
                    @click="getExportSummarys()" />
              </div>
            </h3>
            <BaseTableDetail
                :border="true"
                class="summary-table"
                :table-set-list="exportTableSetList"
                :display-item="exportSummarys" />
            <h3 class="noData">
              {{ exportNoData }}
            </h3>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="edit-table-list">
          <div class="table-vertical">
            <h2 class="totalQty">
              {{ pendingCount }}
            </h2>
            <h3 class="subTitle">
              {{ subTitle[2] }}
              <div class="edit-button-wrap">
                <i
                    class="refresh-icon fas fa-sync-alt"
                    @click="getPendingSummarys()" />
              </div>
            </h3>
            <BaseTableDetail
                :border="true"
                class="summary-table"
                :display-item="pendingSummarys"
                :table-set-list="pendingTableSetList" />
            <h3 class="noData">
              {{ pendingNoData }}
            </h3>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div class="edit-table-list">
          <div class="table-vertical">
            <h3 class="summaryTitle">
              {{ subTitle[3] }}
              <div class="edit-button-wrap">
                <i
                    class="refresh-icon fas fa-sync-alt"
                    @click="getSalesSummarys()" />
              </div>
            </h3>
            <BaseTableList
                class="summary-list"
                :table-set-list="salesTableSetList"
                :display-items="salesSummarys"
                height="450">
              <template
                  slot="message"
                  slot-scope="{ row }">
                <template v-if="hasLink(row.row)">
                  <router-link
                      :to="{ path: getLink(row.row) }">
                    <span
                        class="link-message"
                        @click="onLinkClick(row.row)">{{ getMessage(row.row) }}</span>
                  </router-link>
                </template>
                <template v-else>
                  {{ getMessage(row.row) }}
                </template>
              </template>
            </BaseTableList>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'

import common from '@/utils/common'

import mixin from '@/components/mixins/mixin'
import { ELEMENT_TYPE } from '@/components/molecules/BaseCell'
import BaseTableDetail from '@/components/molecules/BaseTableDetail'
import BaseTableList from '@/components/molecules/BaseTableList'
import * as queries from '@/queries/dashboard'

export default {
  name: 'SummaryTable',
  components: {
    BaseTableDetail,
    BaseTableList
  },
  mixins: [ mixin ],
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  props: {
    type: {
      type: Number,
      default: null,
      validator: function (value) {
        return [null, 1, 2].indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      shipmentSummarys: {
        totalCount: 0,
        unallocated: 0,
        pending: 0,
        preExport: 0,
        exported: 0,
        canceled: 0,
        preReExport: 0,
        receivedShipped: 0
      },
      exportSummarys: {
        totalCount: 0,
        notCreate: 0,
        notSend: 0
      },
      pendingSummarys: {
        totalCount: 0,
        highPrice: 0,
        blackList: 0,
        newCreate: 0,
        duplication: 0,
        credentialNG: 0,
        expired: 0,
        publishingNG: 0,
        product: 0,
        redirection: 0,
        other1: 0,
        other2: 0,
        other3: 0,
        other4: 0
      },
      salesSummarys: [ { date: 0, orderCount: 0, orderPrice: 0, exportCount: 0, exportPrice: 0 } ]
    }
  },
  computed: {
    ...mapGetters('LocalStorage', {
      sortCondition: 'sortCondition'
    }),
    title () {
      return '注文サマリ'
    },
    subTitle () {
      return [
        '注文(配送単位)',
        '出荷指図',
        '保留',
        'レポートサマリ'
      ]
    },
    shipTableSetList () {
      return [
        {
          class: 'right',
          elementType: ELEMENT_TYPE.TAG,
          label: '未引当',
          properties: [
            {
              path: 'unallocated', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.shipmentSummarys.unallocated)
        },
        {
          label: '処理待ち',
          class: 'center order-status-tag',
          properties: [
            {
              path: 'pending', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.shipmentSummarys.pending)
        },
        {
          label: '指図待ち',
          elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag',
          properties: [
            {
              path: 'preExport', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.shipmentSummarys.preExport)
        },
        {
          label: '出荷準備中',
          elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag',
          properties: [
            {
              path: 'exported', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.shipmentSummarys.exported)
        },
        {
          label: '出荷キャンセル',
          elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag',
          properties: [
            {
              path: 'canceled', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.shipmentSummarys.canceled)
        },
        {
          label: '再送指示待ち',
          elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag',
          properties: [
            {
              path: 'preReExport', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.shipmentSummarys.preReExport)
        },
        {
          label: '未処理返品',
          elementType: ELEMENT_TYPE.TAG,
          class: 'center order-status-tag',
          properties: [
            {
              path: 'receivedShipped', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.shipmentSummarys.receivedShipped)
        }
      ]
    },
    shipCount () {
      return this.shipmentSummarys.totalCount
    },
    shipNoData () {
      return (this.shipmentSummarys.totalCount === 0 ? '対象データなし'
        : this.shipmentSummarys.totalCount === '-' ? 'データ未取得' : null)
    },
    exportTableSetList () {
      return [
        {
          label: '指図未作成',
          properties: [
            {
              path: 'notCreate', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.exportSummarys.notCreate)
        },
        {
          label: '指図未送信',
          properties: [
            {
              path: 'notSend', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.exportSummarys.notSend)
        }
      ]
    },
    exportCount () {
      return this.exportSummarys.totalCount
    },
    exportNoData () {
      return (this.exportSummarys.totalCount === 0 ? '対象データなし'
        : this.exportSummarys.totalCount === '-' ? 'データ未取得' : null)
    },
    pendingTableSetList () {
      return [
        {
          label: '高額決済',
          properties: [
            {
              path: 'highPrice', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.highPrice)
        },
        {
          label: 'ブラック',
          properties: [
            {
              path: 'blackList', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.blackList)
        },
        {
          label: '新規作成中',
          properties: [
            {
              path: 'newCreate', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.newCreate)
        },
        {
          label: '重複注文',
          properties: [
            {
              path: 'duplication', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.duplication)
        },
        {
          label: '与信NG',
          properties: [
            {
              path: 'credentialNG', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.credentialNG)
        },
        {
          label: '期限切れ',
          properties: [
            {
              path: 'expired', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.expired)
        },
        {
          label: '発行番号NG',
          properties: [
            {
              path: 'publishingNG', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.publishingNG)
        },
        {
          label: '指定商品',
          properties: [
            {
              path: 'product', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.product)
        },
        {
          label: '届け先変更',
          properties: [
            {
              path: 'redirection', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.redirection)
        },
        {
          label: 'CSその他1',
          properties: [
            {
              path: 'other1', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.other1)
        },
        {
          label: 'CSその他2',
          properties: [
            {
              path: 'other2', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.other2)
        },
        {
          label: 'CSその他3',
          properties: [
            {
              path: 'other3', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.other3)
        },
        {
          label: 'CSその他4',
          properties: [
            {
              path: 'other4', type: 'String', elementType: ELEMENT_TYPE.INPUT,
              validateRule: 'required|max:200', class: 'right'
            }
          ],
          isShow: this.showData(this.pendingSummarys.other4)
        }
      ]
    },
    pendingCount () {
      return this.pendingSummarys.totalCount
    },
    pendingNoData () {
      return (this.pendingSummarys.totalCount === 0 ? '対象データなし'
        : this.pendingSummarys.totalCount === '-' ? 'データ未取得' : null)
    },
    salesTableSetList () {
      return [
        {
          type: 'String', label: '', path: 'date', name: 'date'
        },
        {
          type: 'Number', label: '注文件数', path: 'orderCount', name: 'orderCount', class: 'right'
        },
        {
          elementType: ELEMENT_TYPE.FUNCTION,
          type: 'Number', label: '注文金額', path: (row) => this.getPrice(row.orderPrice), name: 'orderPrice', class: 'right'
        },
        {
          type: 'Number', label: '出荷件数', path: 'exportCount', name: 'exportCount', class: 'right'
        },
        {
          elementType: ELEMENT_TYPE.FUNCTION,
          type: 'Number', label: '出荷金額', path: (row) => this.getPrice(row.exportPrice), name: 'exportPrice', class: 'right'
        }
      ]
    }
  },
  created () {
    this.shipmentSummarys.totalCount = '-'
    this.exportSummarys.totalCount = '-'
    this.pendingSummarys.totalCount = '-'
  },
  methods: {
    ...mapActions('LocalStorage', [
      'setSortCondition'
    ]),
    showData (value) {
      return (value > 0)
    },
    getPrice (row) {
      return common.concatCurrency(row, 'JPY')
    },
    /**
     * サマリ一覧を取得する
     */
    async getShipmentSummarys () {
      try {
        this.$loadingService.show()
        const result = await common.postGraphQl(queries.GRAPH_QL_QUERY_SHIPMENT_SUMMARY)
        this.shipmentSummarys = _.chain(result)
          .get('data.data.shipmentSummarys.edges[0].node', [])
          .reverse()
          .value()
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * サマリ一覧を取得する
     */
    async getExportSummarys () {
      try {
        this.$loadingService.show()
        const result = await common.postGraphQl(queries.GRAPH_QL_QUERY_EXPORT_SUMMARY)
        this.exportSummarys = _.chain(result)
          .get('data.data.exportSummarys.edges[0].node', [])
          .reverse()
          .value()
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * サマリ一覧を取得する
     */
    async getPendingSummarys () {
      try {
        this.$loadingService.show()
        const result = await common.postGraphQl(queries.GRAPH_QL_QUERY_PENDING_SUMMARY)
        this.pendingSummarys = _.chain(result)
          .get('data.data.pendingSummarys.edges[0].node', [])
          .reverse()
          .value()
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    },
    /**
     * サマリ一覧を取得する
     */
    async getSalesSummarys () {
      try {
        this.$loadingService.show()
        const result = await common.postGraphQl(queries.GRAPH_QL_QUERY_SALES_SUMMARY)
        const tempsalesSummarys = _.chain(result)
          .get('data.data.salesSummarys.edges', [])
          .reverse()
          .value()
        this.salesSummarys = []

        for (const tempsalesSummary of tempsalesSummarys) {
          this.salesSummarys.push(tempsalesSummary.node)
        }
      } catch (error) {
        throw error
      } finally {
        this.$loadingService.close()
      }
    }
  }
}
</script>

<style scoped>

.edit-table-list {
  margin: 10px 10px;
}

.title {
  margin: 10;
  border-top: 4px solid #2ea4e1;
  font-size: 16px;
  letter-spacing: .1em;
  color: #343352;
  padding: 15px 10px 15px 30px;
}

.noData,
.subTitle {
  margin: 10;
  font-size: 14px;
  letter-spacing: .1em;
  color: #343352;
  padding: 10px 10px 15px 30px;
}

.summaryTitle {
  margin: 10;
  font-size: 14px;
  letter-spacing: .1em;
  color: #343352;
  padding: 20px 10px 15px 30px;
}

.totalQty {
  margin: 10;
  font-size: 20px;
  letter-spacing: .1em;
  color: #343352;
  padding: 10px 10px 15px 30px;
}

.ship-table, .summary-table {
  padding: 10px 10px 15px 30px;
}

.ship-table ::v-deep th {
  text-align: center;
  border: solid 1px;
}

.summary-list ::v-deep th,
.summary-list ::v-deep td {
  vertical-align: middle;
  line-height: 32px;
  font-size: 15px;
}
.summary-list ::v-deep .el-tag {
  width: 80%;
}

.link-message {
  font-weight: bold;
}
.dashboard-block .refresh-icon,
.dashboard-block-title .refresh-icon {
    display: inline-block;
    position: absolute;
    top:18px;
    cursor : pointer;
}
</style>
